module.exports = __webpack_public_path__ + "img/icon_merck.572ca3e5.png";